<template>
  <el-form
    ref="feesForPaidPassengersForm"
    :model="model"
    :rules="rules"
    label-width="14.5em"
    label-position="left"
    class="fees-for-paid-passengers-form"
  >
    <div class="el-form--inline">
    <BillingYm v-model="billingYm" :required="true" :searchCond="true" :mode="billingYmMode" :disabled="editMode" :autofocus="!editMode" />
    <BillToCode v-model="billToCode" :required="!searchMode" :searchCond="searchMode"
        :disabled="editMode" :autocomplete-list="autocompleteCustomerCodeSet" />
    </div>
    <el-divider />
    <div class="el-form--inline">
      <AirportCode v-model="departureAirportCode" label="出発地" prop="departure_airport_code"
        :required="!searchMode" :disabled="editMode" :searchCond="searchMode" :autocomplete-list="autocompleteAirportCodeSet" />
      <AircraftWeightType v-model="aircraftWeightType" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" :initialize="true" />
    </div>
    <template v-if='formMode === "search"'>
      <div class="el-form--inline">
        <!-- <Seats v-model="seats" :required="!searchMode" :searchCond="searchMode" /> -->
        <Numeric v-model="seats" label="座席数" prop="seats" :required="!searchMode" :searchCond="searchMode" :min="0" :max="999999" :step="1" :disabled="editDisabledMode && editMode" />
        <!-- <PaidPassengers v-model="paidPassengers" :required="!searchMode" :searchCond="searchMode" /> -->
        <Numeric v-model="paidPassengers" label="有償旅客数" prop="paid_passengers" :required="!searchMode" :searchCond="searchMode" :min="0" :max="999999" :step="1" :disabled="editDisabledMode && editMode" />
      </div>
    </template>
    <template v-else>
      <div class="el-form--inline">
        <!-- <Seats v-model="seats" :required="!searchMode" :searchCond="searchMode" /> -->
        <Numeric v-model="seats" label="座席数" placeholder="0～999999" prop="seats" :required="!searchMode" :searchCond="searchMode" :min="0" :max="999999" :step="1" :disabled="editDisabledMode && editMode" />
        <!-- <PaidPassengers v-model="paidPassengers" :required="!searchMode" :searchCond="searchMode" /> -->
        <Numeric v-model="paidPassengers" label="有償旅客数" placeholder="0～999999" prop="paid_passengers" :required="!searchMode" :searchCond="searchMode" :min="0" :max="999999" :step="1" :disabled="editDisabledMode && editMode" />
      </div>
    </template>
    <el-divider />
    <div class="el-form--inline">
      <Taxation v-model="taxation" :required="!searchMode" :searchCond="searchMode" :initialize="true" :disabled="editDisabledMode && editMode" />
      <template v-if='formMode === "search"'>
        <Numeric v-model="tax" label="税率[%]" prop="tax" :required="!searchMode" :disabled="editMode" :searchCond="searchMode" :min="0" :max="99" :step="1" />
      </template>
      <template v-else-if='formMode === "edit"'>
        <Numeric v-model="tax" label="税率[%]" placeholder="0～99" prop="tax" :required="!searchMode" :disabled="editMode" :searchCond="searchMode" :min="0" :max="99" :step="1" />
      </template>
      <template v-else>
        <Blank />
      </template>
    </div>
    <div class="el-form--inline">
      <ExemptionCode v-model="exemptionCode" :required="!searchMode" :initialize="true" :searchCond="searchMode" :disabled="editDisabledMode && editMode" />
      <ExemptionRate v-model="exemptionRate" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode && editMode" />
    </div>
    <div class="el-form--inline">
      <Numeric v-model="unitFee" label="単位料金[円]" prop="unit_fee"
        :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999999" :disabled="editDisabledMode && editMode" />
      <Numeric v-model="passengerLandingFeeBeforeExemption" label="旅客数着陸料(減免前)[円]" prop="passenger_landing_fee_before_exemption"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
    </div>
    <div class="el-form--inline">
      <Numeric v-model="passengerLandingFeeWithoutTax" label="旅客数着陸料(税抜)[円]" prop="passenger_landing_fee_without_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
      <Numeric v-model="passengerLandingFeeTax" label="旅客数着陸料(税)[円]" prop="passenger_landing_fee_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
    </div>
    <div class="el-form--inline">
      <Numeric v-model="passengerLandingFeeWithTax" label="旅客数着陸料(税込)[円]" prop="passenger_landing_fee_with_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
      <!-- <RegistType v-model="registType" :required="!searchMode" :searchCond="searchMode" :disabled="!searchMode"/> -->
      <template v-if='formMode === "search"'>
        <div class="parent_Box">
          <div class="child_Box">
            <el-checkbox v-model="manualDataOnly" v-if="searchMode" :searchCond="searchMode" >検索結果に補正登録データのみ表示する</el-checkbox>
          </div>
          <div class="child_Box">
            <el-checkbox v-model="automaticDataOnly" v-if="searchMode" :searchCond="searchMode" >検索結果に自動入力データのみ表示する</el-checkbox>
          </div>
        </div>
      </template>
      <template v-else>
        <Blank />
      </template>
    </div>
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import AircraftWeightType from '@/components/molecules/form/select/AircraftWeightType.vue'
// import Seats from '@/components/molecules/form/number/Seats.vue'
// import PaidPassengers from '@/components/molecules/form/number/PaidPassengers.vue'
// import Tax from '@/components/molecules/form/number/Tax.vue'
import Taxation from '@/components/molecules/form/select/Taxation.vue'
import ExemptionCode from '@/components/molecules/form/select/ExemptionCode.vue'
import ExemptionRate from '@/components/molecules/form/text/ExemptionRate.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'
// import Fee from '@/components/molecules/form/text/Fee.vue'
// import RegistType from '@/components/molecules/form/text/RegistType.vue'

export default {
  components: {
    BillingYm,
    BillToCode,
    AirportCode,
    AircraftWeightType,
    // Seats,
    // PaidPassengers,
    // Tax,
    Taxation,
    ExemptionCode,
    ExemptionRate,
    Numeric,
    Blank
    // Fee
    // RegistType
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    billingYmMode: {
      type: String,
      default: 'search'
    },
    editDisabledMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    },
    billToCode: {
      get () {
        return this.model.bill_to_code
      },
      set (billToCode) {
        const form = { ...this.model }
        form.bill_to_code = billToCode
        this.$emit('input', form)
      }
    },
    departureAirportCode: {
      get () {
        return this.model.departure_airport_code
      },
      set (departureAirportCode) {
        const form = { ...this.model }
        form.departure_airport_code = departureAirportCode
        this.$emit('input', form)
      }
    },
    aircraftWeightType: {
      get () {
        return this.model.aircraft_weight_type
      },
      set (aircraftWeightType) {
        const form = { ...this.model }
        form.aircraft_weight_type = aircraftWeightType
        this.$emit('input', form)
      }
    },
    seats: {
      get () {
        return this.model.seats
      },
      set (seats) {
        const form = { ...this.model }
        form.seats = seats
        this.$emit('input', form)
      }
    },
    paidPassengers: {
      get () {
        return this.model.paid_passengers
      },
      set (paidPassengers) {
        const form = { ...this.model }
        form.paid_passengers = paidPassengers
        this.$emit('input', form)
      }
    },
    tax: {
      get () {
        return this.model.tax
      },
      set (tax) {
        const form = { ...this.model }
        form.tax = tax
        this.$emit('input', form)
      }
    },
    taxation: {
      get () {
        return this.model.taxation
      },
      set (taxation) {
        const form = { ...this.model }
        form.taxation = taxation
        this.$emit('input', form)
      }
    },
    exemptionCode: {
      get () {
        return this.model.exemption_code
      },
      set (exemptionCode) {
        const form = { ...this.model }
        form.exemption_code = exemptionCode
        this.$emit('input', form)
      }
    },
    exemptionRate: {
      get () {
        return this.model.exemption_rate
      },
      set (exemptionRate) {
        const form = { ...this.model }
        form.exemption_rate = exemptionRate
        this.$emit('input', form)
      }
    },
    unitFee: {
      get () {
        return this.model.unit_fee
      },
      set (unitFee) {
        const form = { ...this.model }
        form.unit_fee = unitFee
        this.$emit('input', form)
      }
    },
    passengerLandingFeeBeforeExemption: {
      get () {
        return this.model.passenger_landing_fee_before_exemption
      },
      set (passengerLandingFeeBeforeExemption) {
        const form = { ...this.model }
        form.passenger_landing_fee_before_exemption = passengerLandingFeeBeforeExemption
        this.$emit('input', form)
      }
    },
    passengerLandingFeeWithoutTax: {
      get () {
        return this.model.passenger_landing_fee_without_tax
      },
      set (passengerLandingFeeWithoutTax) {
        const form = { ...this.model }
        form.passenger_landing_fee_without_tax = passengerLandingFeeWithoutTax
        this.$emit('input', form)
      }
    },
    passengerLandingFeeTax: {
      get () {
        return this.model.passenger_landing_fee_tax
      },
      set (passengerLandingFeeTax) {
        const form = { ...this.model }
        form.passenger_landing_fee_tax = passengerLandingFeeTax
        this.$emit('input', form)
      }
    },
    passengerLandingFeeWithTax: {
      get () {
        return this.model.passenger_landing_fee_with_tax
      },
      set (passengerLandingFeeWithTax) {
        const form = { ...this.model }
        form.passenger_landing_fee_with_tax = passengerLandingFeeWithTax
        this.$emit('input', form)
      }
    },
    manualDataOnly: {
      get () {
        return this.model.manual_data_only
      },
      set (manualDataOnly) {
        const form = { ...this.model }
        form.manual_data_only = manualDataOnly
        this.$emit('input', form)
        if (manualDataOnly === true) {
          form.automatic_data_only = false
        }
      }
    },
    automaticDataOnly: {
      get () {
        return this.model.automatic_data_only
      },
      set (automaticDataOnly) {
        const form = { ...this.model }
        form.automatic_data_only = automaticDataOnly
        this.$emit('input', form)
        if (automaticDataOnly === true) {
          form.manual_data_only = false
        }
      }
    },
    // registType: {
    //   get () {
    //     return this.model.regist_type
    //   },
    //   set (registType) {
    //     const form = { ...this.model }
    //     form.regist_type = registType
    //     this.$emit('input', form)
    //   }
    // },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
    // editDisabledMode: {
    //   get () {
    //     return this.model.regist_type === '1' || parseInt(this.model.billing_ym) < parseInt(this.getDefaultBillingYm())
    //   }
    // }
  },
  mounted () {
  },
  methods: {
    clearFields () {
      this.$refs.feesForPaidPassengersForm.resetFields()
      this.billingYm = this.getDefaultBillingYm()
      if (this.searchMode) {
        this.model.manual_data_only = false
        this.model.automatic_data_only = false
      }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.feesForPaidPassengersForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.fees-for-paid-passengers-form {
  .el-form--inline {
    display: flex;
    justify-content: space-between;
    // margin-left: 10px;
  }
}
</style>
